import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SettingsService } from '@core';
import { MenuService } from '@core/bootstrap/menu.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Select } from '@ngxs/store';
import { SettingsState } from 'app/redux/state/settings.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() nav: any[] = [];
  @Input() detail: string;

  @Select(SettingsState.breadcrumbDetail)
  breadcrumbDetail$: Observable<String>;
  @Select(SettingsState.title)
  title$: Observable<String>;

  breadcrumbDetail: String;
  constructor(
    private router: Router,
    private menuService: MenuService,
    private localize: LocalizeRouterService,
    public settings: SettingsService
  ) {
    this.generateBreadCrumb();
    // TODO: Scroll top to container
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.generateBreadCrumb();
      }
    });

    this.breadcrumbDetail$.subscribe(breadcrumbDetail => {
      this.breadcrumbDetail = breadcrumbDetail;
      this.generateBreadCrumb();
    });

    this.title$.subscribe(title => {
      this.generateBreadCrumb();
    });
  }

  ngOnInit() {
    this.generateBreadCrumb();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.detail) {
      this.generateBreadCrumb();
    }
  }

  generateBreadCrumb() {
    this.nav = [];

    if (this.nav.length === 0) {
      this.genBreadcrumb();
    }

    if (this.detail) {
      this.nav.push({ name: this.detail });
    }
  }

  trackByNavlink(index: number, navlink: string): string {
    return navlink;
  }

  genBreadcrumb() {
    const states = this.router.url.slice(1).split('/');

    this.nav = this.menuService.getMenuLevel(states);
    this.nav.unshift({ name: 'menu.home' });

    this.nav.forEach(item => {
      if (item.route) {
        item.route = this.localize.translateRoute(item.route);
      }
    });

    if (states.length > this.nav.length && this.breadcrumbDetail != null) {
      this.nav.push({ name: this.breadcrumbDetail });
    }
  }
}
